import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { SelectOptions } from "components/Shared/CustomSelect/CustomSelect";

export default function MDSelect({
  fullWidth,
  value,
  onChange,
  defaultValue,
  label,
  error,
  name,
  options,
  readOnly,
  open,
  onOpen,
  onClose,
}: {
  fullWidth: boolean;
  defaultValue?: string;
  value: string;
  onChange: (e: SelectChangeEvent) => void;
  label: string;
  name: string;
  readOnly?: boolean;
  error?: boolean;
  options: SelectOptions;
  /** Controls the menu's open state. Omit to let MUI manage it uncontrolled. */
  open?: boolean;
  onOpen?: () => void;
  onClose?: () => void;
}) {
  const selected = value;

  return (
    <FormControl
      fullWidth={fullWidth}
      sx={
        selected
          ? {
              "&": {
                mt: "3px",
              },
            }
          : {
              "&": {
                py: "10px",
              },
            }
      }
    >
      <InputLabel
        sx={{
          "&": {
            marginLeft: "-12px",
          },
          ...(selected
            ? {
                top: "8px",
              }
            : {}),
        }}
      >
        {label}
      </InputLabel>
      <Select
        variant={"standard"}
        error={error}
        readOnly={readOnly}
        sx={{
          "& > #mui-component-select-role": {
            padding: "0 0 5px !important",
          },
          ...(selected
            ? {
                "& > div": {
                  marginTop: "6px",
                },
              }
            : {}),
        }}
        onChange={onChange}
        defaultValue={defaultValue ?? selected}
        value={value}
        {...(open !== undefined ? { open, onOpen, onClose } : {})}
      >
        {options?.map(({ label, value }) => (
          <MenuItem
            data-test-id={`select-${name}-option`}
            value={value}
            key={value}
            selected={value === selected}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
